type Callback = () => void; 
type SlideOptions = {
  duration?: number; 
  callback?: Callback; 
  isDown?: boolean;
}

export interface ISlider {
  slideToggle: (duration?: number, callback?: Callback) => void;
  slideUp: (duration?: number, callback?: Callback) => void;
  slideDown: (duration?: number, callback?: Callback) => void;
};

export default function GetElementSlider(element: HTMLElement) {
  const object: ISlider = {
    slideToggle: slideToggle.bind(element),
    slideUp: slideUp.bind(element),
    slideDown: slideDown.bind(element)
  };

  return object;
}

export function slideToggle(duration?: number, callback?: Callback) {
  if(this.clientHeight === 0) {
    _slideVertical(this, { duration, callback, isDown: true });
  } else {
    _slideVertical(this, { duration, callback });
  }
}
  
export function slideUp(duration?: number, callback?: Callback) {
  _slideVertical(this, { duration, callback });
}
  
export function slideDown(duration?: number, callback?: Callback) {
  _slideVertical(this, { duration, callback, isDown: true });
}

function _slideVertical(el: HTMLElement, options?: SlideOptions) {
  const { duration = 400, callback, isDown = false } = options ?? {};

  el.style.overflow = "hidden";

  if(isDown) { 
    el.style.display = "block"; 
  }
  
  const elStyles        = window.getComputedStyle(el);

  const elHeight        = parseFloat(elStyles.getPropertyValue('height'));
  const elPaddingTop    = parseFloat(elStyles.getPropertyValue('padding-top'));
  const elPaddingBottom = parseFloat(elStyles.getPropertyValue('padding-bottom'));
  const elMarginTop     = parseFloat(elStyles.getPropertyValue('margin-top'));
  const elMarginBottom  = parseFloat(elStyles.getPropertyValue('margin-bottom'));
  
  const stepHeight        = elHeight        / duration;
  const stepPaddingTop    = elPaddingTop    / duration;
  const stepPaddingBottom = elPaddingBottom / duration;
  const stepMarginTop     = elMarginTop     / duration;
  const stepMarginBottom  = elMarginBottom  / duration;
  
  let start: number;
  
  function step(timestamp: number) { 
    if(start === undefined) { 
      start = timestamp; 
    }
  
    const elapsed = timestamp - start;
  
    if(isDown) {
      el.style.height        = (stepHeight        * elapsed) + "px";
      el.style.paddingTop    = (stepPaddingTop    * elapsed) + "px";
      el.style.paddingBottom = (stepPaddingBottom * elapsed) + "px";
      el.style.marginTop     = (stepMarginTop     * elapsed) + "px";
      el.style.marginBottom  = (stepMarginBottom  * elapsed) + "px";
    } else {
      el.style.height        = elHeight        - (stepHeight        * elapsed) + "px";
      el.style.paddingTop    = elPaddingTop    - (stepPaddingTop    * elapsed) + "px";
      el.style.paddingBottom = elPaddingBottom - (stepPaddingBottom * elapsed) + "px";
      el.style.marginTop     = elMarginTop     - (stepMarginTop     * elapsed) + "px";
      el.style.marginBottom  = elMarginBottom  - (stepMarginBottom  * elapsed) + "px";
    }
  
    if(elapsed >= duration) {
      el.style.height        = "";
      el.style.paddingTop    = "";
      el.style.paddingBottom = "";
      el.style.marginTop     = "";
      el.style.marginBottom  = "";
      el.style.overflow      = "";

      if(!isDown) { 
        el.style.display = "none";
      }

      if(typeof callback === "function") { 
        callback();
      }
    } else {
      window.requestAnimationFrame(step);
    }
  }
  
  window.requestAnimationFrame(step);
}